var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSameline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.75 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, " -->\n  ", /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.75 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #9aca3c;\n      }\n\n      .cls-2 {\n      letter-spacing: 0em;\n      }\n\n      .cls-3 {\n      letter-spacing: -.01em;\n      }\n\n      .cls-4 {\n      font-family: 'Nunito Sans', sans-serif;\n      font-size: 12px;\n      }\n\n      .cls-4, .cls-5 {\n      fill: #2196f3;\n      }\n\n      .cls-6 {\n      fill: none;\n      stroke: #2196f3;\n      stroke-miterlimit: 10;\n      }\n\n      .cls-7 {\n      letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(34.28 14.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "Leaflit Care Inc")), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.81,
    x2: 28.81,
    y2: 22.68
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.44,16.09c-.7.18-1.33.34-1.96.51-.42.12-.66-.04-.75-.45-.22-.95-.48-1.9-.63-2.86-.08-.54-.33-.82-.82-.8-1.12.04-1.66-.59-1.94-1.56-.22-.78-.7-1.34-1.46-1.6-.66-.23-1.34-.45-2.03-.54-.56-.07-.74-.26-.56-.78.24-.67.47-1.35.72-2.03l.1-.23c-3.5.84-6.1,4-6.1,7.76,0,4.41,3.57,7.98,7.98,7.98,3.51,0,6.5-2.27,7.56-5.43l-.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.23,7.53c1.64.17,3.09.68,3.57,2.53.2.77.77,1.1,1.53,1.11.81.01,1.07.45,1.16,1.2.1.81.34,1.6.51,2.39.1.47.39.45.84.51,3.32-.6,5.84-3.5,5.84-6.99,0-3.92-3.18-7.1-7.1-7.1-3.55,0-6.49,2.6-7.02,6,.05.23.26.31.66.35Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSameline);
export default __webpack_public_path__ + "static/media/LogoSameline.29932a86eef32e0f6a5a267d6b00fe2f.svg";
export { ForwardRef as ReactComponent };